<template lang="pug">
  #app
    TopSmoke
    #leftNav
      router-link(to='/')
        img(src="/img/logo.png")
      span The OFFERING The CHAIRMAN
      img.ringoffire(src="/img/logo-01.png")
    #nav
      .navlist
        img.hamburger( @click="navi" src="/img/hamburger.png" )        
        transition(name="fade")
          //- .navi(v-bind:class="{active : hamburger}")
          .navi(v-if="hamburger")
            .close(@click="navi") X
            router-link(to='/') HOME
            router-link(to='/album') ALBUM
            router-link(to='/lyrics') MV | LYRICS
            router-link(to='/members') The CHAIRMAN 
            a(href="https://www.dagishoang.com.tw") DA GI SHOANG
    transition(name="fade" mode="out-in")
      router-view
    BottomSmoke
    

</template>
<script>
window.$ = require('jquery');
import TopSmoke from '@/components/TopSmoke.vue'
import BottomSmoke from '@/components/BottomSmoke.vue'

export default {
  data: function(){
    return{
      hamburger:false
    }
  },
  components:{
    TopSmoke,
    BottomSmoke
  },
  watch:{
  },
  methods:{
    navi:function(){
      this.hamburger = !this.hamburger;
    }
  }
}
</script>

<style lang="scss">
body{
  background-color:#222;
}
.close{
  display:none;
}
.ringoffire{
  margin-top:300px;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.7s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.hamburger{
  float:right;
  width:40px;
  margin-left:30px;
  cursor: pointer;
}
#leftNav{
  width:50px;
  position:fixed;
  padding:10px;
  height:100vh;
  span{
    transform: rotate(90deg);
    width:350px;
    position:absolute;
    top:250px;
    left:-150px;

}
  img{
    width:100%;
  }
}
.navlist{
  width:100%;
  height:24px;
  text-align: right;
}
#nav {
  padding: 30px;
  z-index:9;
  a{
    color:#757676;
    transition:color .3s;
    margin:0 20px;
    padding:30px inherit;
  }
  a:hover{
    color:#BCBEBD;
  }
  .hamburger{

  }
 
}
@media(max-width:414px){
  #leftNav{
    display:none;
  }
  .close{
    display:block;
    position:absolute;
    top:10px;
    right:10px;
    color:#757676;
  }

  .navi{
    display:block;
    position:fixed;
    top:0;
    left:0;
    padding-top:20px;
    padding-bottom:20px;
    width:100%;
    overflow:auto;
    background:#222;
    z-index:8;
    a{
      display:block;
      float:left;
      clear:both;
      margin-top:15px !important;
    }
  }
  
}
</style>
